/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Hero_NoteInputs */

const en_control_hero_note = /** @type {(inputs: Control_Hero_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free tools. No account required. Answers first.`)
};

const zh_control_hero_note = /** @type {(inputs: Control_Hero_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费工具，无需账号，答案优先。`)
};

/**
* | output |
* | --- |
* | "Free tools. No account required. Answers first." |
*
* @param {Control_Hero_NoteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_hero_note = /** @type {((inputs?: Control_Hero_NoteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Hero_NoteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_hero_note(inputs)
	return zh_control_hero_note(inputs)
});
export { control_hero_note as "control.hero.note" }